import { z } from 'zod';

export const CreateOrganizationBodySchema = z.object({
    name: z.string().min(2, 'Organization name must be at least 2 characters long')
});
export type CreateOrganizationRequest = z.infer<typeof CreateOrganizationBodySchema>;

export const UpdateOrganizationBodySchema = z.object({
    name: z.string().min(2, 'Organization name must be at least 2 characters long')
});
export type UpdateOrganizationRequest = z.infer<typeof UpdateOrganizationBodySchema>;

export const InviteMembersRequestBodySchema = z.object({
    emails: z.array(z.string().email('Invalid email format')).min(1, 'At least one email is required')
});
export type InviteMembersRequestBody = z.infer<typeof InviteMembersRequestBodySchema>;
